import { css } from "@emotion/react";
import { COLORS } from "styles/global/globalColors";

const initFonts = css`
    * {
        font-family: 'Poppins', sans-serif;
        color: ${COLORS.black};
    }
`;

export default initFonts;